import * as firebase from 'firebase/app'
import 'firebase/performance' // Firebase Performance Monitorinf
import 'firebase/auth' // Firebase authentication

export default firebase
